// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-y: auto; /* Allow vertical scrolling */
}

.about-body {
  color: white;
}

.about-wrapper {
  /* display: flex; */
  box-sizing: border-box;
  /* padding-top: 64px; */
  /* height: 100vh; */
  background-color: var(--background-color); /* Dark background */
  color: var(--text-color); /* Text color */
  font-family: "Montserrat", sans-serif; 
}

/* General Styling */
.about-root {
  font-family: 'Tussilago', 'Montserrat', sans-serif;
  color: #333;
  background-color: #f9f9f9;
  padding: 0;
  margin: 0;
}

.about-header {
  text-align: center;
  padding: 20px 0;
  background-color: #1f2238;
  color: white;
}

.about-logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.about-logo {
  height: 60px;
}

.about-title {
  font-size: 36px;
  font-weight: bold;
}

/* Hero Section */
.about-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  /* background: linear-gradient(to right, #0087e1, #111920); */
  color: white;
  height: 100%;
}

/* .hero-text {
  max-width: 50%;
} */

.hero-text h2 {
  font-size: 42px;
  margin-bottom: 20px;
}

.hero-text p {
  font-size: 18px;
  line-height: 1.6;
}

.hero-image img {
  max-width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

/* Content Section */
.about-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 50px;
}

.content-block {
  background: white;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.content-block:hover {
  transform: translateY(-5px);
}

.content-block h3 {
  font-size: 24px;
  color: #1f2238;
  margin-bottom: 50px;
}

.content-block p {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

/* Responsive Design */
@media (max-width: 768px) {
  .about-hero {
    flex-direction: column;
    text-align: center;
  }

  .hero-text {
    max-width: 100%;
    margin-bottom: 20px;
  }

  .about-content {
    grid-template-columns: 1fr;
  }
}

/* Features Section */
.about-features {
  padding: 50px;
  background-color: #f2f2f2;
  color: #333;
  height: 100%;
}

.about-features h3 {
  font-size: 28px;
  margin-bottom: 20px;
}

.about-features ul {
  list-style-type: none;
  margin: 0;
  padding-left: 0px;
}

.about-features li {
  margin-bottom: 15px;
  font-size: 16px;
}

/* FAQ Section */
.about-faqs {
  padding: 50px;
  background-color: #1f2238;
  color: white;
  height: 100%;
}

.about-faqs h3 {
  font-size: 28px;
  margin-bottom: 20px;
}

.about-faqs ul {
  /* color: #0087e1; */
  list-style-type: none;
  padding-left: 0px;
  margin-left: 0px;
}

.about-faqs li {
  color: #0087e1;
  list-style-type: none;
  padding-left: 0px;
  margin-left: 0px;
}

.faq-item {
  margin-bottom: 20px;
}

.faq-item h4 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #0087e1;
}

.faq-item p {
  font-size: 18px;
}

.horizontal-about-section {
  display: flex;
  flex-direction: column; /* Stack content vertically */
  align-items: center; /* Center content horizontally */
  justify-content: center; /* Center content vertically, if needed */
  min-width: 100vh; /* Full page width */
  box-sizing: border-box; /* Include padding and border in width */
  background: linear-gradient(to top, var(--background-color), #0052a4);
  color: var(--text-color); /* Adjust as needed */
  flex-direction: row;
  height: 110vh;
}

.horizontal-about-section-full {
  display: flex;
  padding-top: 50px;
  flex-direction: column; /* Stack content vertically */
  align-items: center; /* Center content horizontally */
  justify-content: center; /* Center content vertically, if needed */
  width: 100%; /* Full page width */
  box-sizing: border-box; /* Include padding and border in width */
  /* padding: 50px 20px;  */
  background: linear-gradient(to bottom, var(--background-color), #0052a4);
  /* background-color: #0052a4; */
  color: var(--text-color); /* Adjust as needed */
  flex-direction: row;
  height: 100%;
}

.horizontal-about-section-gradient {
  display: flex;
  flex-direction: column; /* Stack content vertically */
  align-items: center; /* Center content horizontally */
  justify-content: center; /* Center content vertically, if needed */
  width: 100%; /* Full page width */
  box-sizing: border-box; /* Include padding and border in width */
  background: linear-gradient(to bottom, var(--background-color), var(--background-color));
  color: var(--text-color); /* Adjust as needed */
  flex-direction: row;
  height: 100%;
}

.about-section-container {
  align-items: flex-start;
  color: rgb(255, 255, 255);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-family: "Capsule Sans Text", sans-serif;
  justify-content: flex-start;
  margin-left: 0px;
  margin-right: 0px;
  text-align: center;
  width: 100%;
  -moz-box-pack: start;
  -moz-osx-font-smoothing: grayscale
}

.about-content-wrapper {
  color: rgb(255, 255, 255);
  display: block;
  font-family: "Capsule Sans Text", sans-serif;
  margin-left: 0px;
  margin-right: 0px;
  text-align: center;
  visibility: visible;
  width: 100%;
  -moz-osx-font-smoothing: grayscale
}

.about-grid {
  align-items: center;
  color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  font-family: "Capsule Sans Text", sans-serif;
  text-align: center;
  visibility: visible;
  width: 100%;
  -moz-box-align: center;
  -moz-osx-font-smoothing: grayscale
}

/* .about-feature {
  color: rgb(255, 255, 255);
  display: flex;
  font-family: "Capsule Sans Text", sans-serif;
  height: 100%;
  justify-content: start;
  margin-bottom: 77px;
  margin-top: 50px;
  overflow-x: auto;
  overflow-y: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  text-align: center;
  visibility: visible;
  width: 100%;
  -moz-box-pack: start;
  -moz-osx-font-smoothing: grayscale
} */

.about-feature {
  display: grid; /* Use grid layout */
  grid-template-columns: repeat(auto-fit, minmax(400px, 0fr)); /* Adjust column size */
  grid-gap: 24px; /* Space between grid items */
  color: rgb(255, 255, 255);
  font-family: "Capsule Sans Text", sans-serif;
  justify-content: center; /* Center content horizontally */
  align-items: start; /* Align items vertically */
  margin-bottom: 77px;
  margin-top: 50px;
  text-align: center;
  visibility: visible;
  width: 100%;
  -moz-osx-font-smoothing: grayscale;
}

.css-131lmaj {
  align-items: center;
  color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  font-family: "Capsule Sans Text", sans-serif;
  height: 100%;
  margin-left: 82.5px;
  margin-right: 55px;
  min-height: 100%;
  scroll-snap-align: center;
  scroll-snap-stop: always;
  text-align: center;
  visibility: visible;
  width: 270px;
  -moz-box-align: center;
  -moz-osx-font-smoothing: grayscale
}

.icon-container {
  color: rgb(255, 255, 255);
  font-family: "Capsule Sans Text", sans-serif;
  height: 200px;
  margin-bottom: 24px;
  text-align: center;
  visibility: visible;
  width: 270px;
  -moz-osx-font-smoothing: grayscale
}

.feature-description {
  color: rgb(255, 255, 255);
  font-family: "Montserrat", sans-serif; 
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.25px;
  line-height: 26px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  text-align: center;
  visibility: visible;
  -moz-osx-font-smoothing: grayscale
}

.feature-title {
  color: rgb(255, 255, 255);
  font-family: "Montserrat", sans-serif; 
  font-size: 20px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: -0.25px;
  line-height: 26px;
  margin-bottom: 10px;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  text-align: center;
  visibility: visible;
  -moz-osx-font-smoothing: grayscale
}

.feature-icon-wrapper {
  align-items: center;
  color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  font-family: "Capsule Sans Text", sans-serif;
  height: 500px;
  margin-left: 0px;
  margin-right: 55px;
  min-height: 100%;
  scroll-snap-align: center;
  scroll-snap-stop: always;
  text-align: center;
  visibility: visible;
  width: 350px;
  -moz-box-align: center;
  -moz-osx-font-smoothing: grayscale
}

.css-2xd1cm {
  align-items: center;
  color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  font-family: "Capsule Sans Text", sans-serif;
  height: 100%;
  margin-left: 0px;
  margin-right: 82.5px;
  min-height: 100%;
  scroll-snap-align: center;
  scroll-snap-stop: always;
  text-align: center;
  visibility: visible;
  width: 270px;
  -moz-box-align: center;
  -moz-osx-font-smoothing: grayscale
}

.about-icon-img {
  /* max-width: 100%; */
  max-height: 100%;
  /* width: 100%; */
  height: 100%;
}

.col-acoordion {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  font-family: "Montserrat", sans-serif; 
  height: 100%;
  width: 100%;
  font-weight: 400;
  margin-left: 40px;
  text-align: center;
  -moz-osx-font-smoothing: auto;
  --section-relative-margin: 0 auto
}

.faq-container {
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif; 
  font-weight: 400;
  height: 100%;
  width: 100%;
  text-align: center;
  -moz-osx-font-smoothing: auto;
  --section-relative-margin: 0 auto
}

.faq-item h1 {
  font-size: 27.7392px;
}

.faq-accordion {
  align-items: center;
  border-bottom-color: white;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-family: "Montserrat", sans-serif; 
  font-weight: 400;
  justify-content: space-between;
  padding-bottom: 16px;
  padding-left: 0px;
  padding-right: 0px;
  /* padding-top: 150px; */
  position: relative;
  text-align: center;
  width: 548px;
  -moz-box-align: center;
  -moz-box-pack: justify;
  -moz-osx-font-smoothing: auto;
  --section-relative-margin: 0 auto
}

.faq-accordion-first {
  align-items: center;
  border-bottom-color: white;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-family: "Montserrat", sans-serif; 
  font-weight: 400;
  justify-content: space-between;
  padding-bottom: 16px;
  padding-left: 0px;
  padding-right: 0px;
  margin-top: 10px;
  position: relative;
  text-align: center;
  width: 548px;
  -moz-box-align: center;
  -moz-box-pack: justify;
  -moz-osx-font-smoothing: auto;
  --section-relative-margin: 0 auto
}

.faq-question {
  box-sizing: border-box;
  color: white;
  cursor: pointer;
  font-family: "Montserrat", sans-serif; 
  font-size: 27.7392px;
  font-weight: 400;
  line-height: 34px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-right: 16px;
  margin-top: 0px;
  overflow-wrap: break-word;
  text-align: left;
  -moz-osx-font-smoothing: auto;
  --section-relative-margin: 0 auto
}

.accordion-item__icon {
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  font-family: "Montserrat", sans-serif; 
  font-weight: 400;
  height: 16px;
  min-width: 16px;
  position: relative;
  text-align: center;
  width: 16px;
  -moz-osx-font-smoothing: auto;
  --section-relative-margin: 0 auto
}

.faq-panel {
  box-sizing: border-box;
  color: white;
  font-family: "Montserrat", sans-serif; 
  font-weight: 400;
  text-align: left;
  max-width: 60%;
  margin-bottom: 50px;
  line-height: 27px;
  font-size: 18px;
  transition-behavior: normal;
  transition-delay: 0s;
  transition-duration: 0.25s;
  transition-property: max-height;
  transition-timing-function: ease-out;
  -moz-osx-font-smoothing: auto;
  --section-relative-margin: 0 auto
}

/* Responsive Design */
@media (max-width: 768px) {
  .about-hero {
    text-align: center;
    justify-content: center;
    padding-top: 70px;
  }

  .hero-text h2 {
    font-size: 24px;
  }

  .hero-text p {
    font-size: 14px;
  }

  .about-content {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .content-block h3 {
    font-size: 18px;
  }

  .content-block p {
    font-size: 12px;
  }

  .about-features {
    padding: 16px;
  }

  .about-features h3 {
    font-size: 20px;
  }

  .about-faqs {
    padding: 16px;
  }

  .faq-item h4 {
    font-size: 16px;
  }

  .faq-panel p {
    font-size: 12px;
  }

  .faq-question {
    font-size: 20px;
  }

  .faq-item h1 {
    font-size: 20px;
  }

  .faq-accordion-first {
    width: 100%;
  }

  .faq-accordion {
    width: 100%;
  }

  .feature-icon-wrapper {
    width: 100%;
    height: 100%;
  }

  .feature-description {
    font-size: 12px;
    width: 70%;
  }

  .feature-title {
    width: 70%;
  }

  .horizontal-about-section,
  .horizontal-about-section-full,
  .horizontal-about-section-gradient {
    padding: 16px;
  }
}

@media (max-width: 1080px) {
  .horizontal-about-section {
    flex-direction: column;
    height: auto;
  }

  .about-hero {
    padding-top: 70px;
    padding-bottom: 0px;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .horizontal-about-section {
    padding: 16px;
    flex-direction: column;
    min-width: auto;
    height: 100%;
  }

  .about-hero .hero-text h2 {
    font-size: 24px;
    margin-bottom: 12px;
  }

  .about-hero .hero-text p {
    font-size: 14px;
  }

  .about-content {
    grid-template-columns: 1fr; /* Stacks content blocks vertically */
    padding: 16px;
    gap: 12px;
  }

  .content-block h3 {
    font-size: 18px;
  }

  .content-block p {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .about-hero .hero-text h2 {
    font-size: 20px;
  }

  .about-hero .hero-text p {
    font-size: 12px;
  }

  .content-block h3 {
    font-size: 16px;
  }

  .content-block p {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/About.css"],"names":[],"mappings":"AAGA;EACE,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC,EAAE,oBAAoB;EAC/D,wBAAwB,EAAE,eAAe;EACzC,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,kDAAkD;EAClD,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,6BAA6B;EACrD,mBAAmB,EAAE,gCAAgC;EACrD,uBAAuB,EAAE,yCAAyC;EAClE,gBAAgB,EAAE,oBAAoB;EACtC,sBAAsB,EAAE,wCAAwC;EAChE,qEAAqE;EACrE,wBAAwB,EAAE,qBAAqB;EAC/C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB,EAAE,6BAA6B;EACrD,mBAAmB,EAAE,gCAAgC;EACrD,uBAAuB,EAAE,yCAAyC;EAClE,WAAW,EAAE,oBAAoB;EACjC,sBAAsB,EAAE,wCAAwC;EAChE,yBAAyB;EACzB,wEAAwE;EACxE,+BAA+B;EAC/B,wBAAwB,EAAE,qBAAqB;EAC/C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,6BAA6B;EACrD,mBAAmB,EAAE,gCAAgC;EACrD,uBAAuB,EAAE,yCAAyC;EAClE,WAAW,EAAE,oBAAoB;EACjC,sBAAsB,EAAE,wCAAwC;EAChE,wFAAwF;EACxF,wBAAwB,EAAE,qBAAqB;EAC/C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB;AACF;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,aAAa,EAAE,oBAAoB;EACnC,2DAA2D,EAAE,uBAAuB;EACpF,cAAc,EAAE,6BAA6B;EAC7C,yBAAyB;EACzB,4CAA4C;EAC5C,uBAAuB,EAAE,gCAAgC;EACzD,kBAAkB,EAAE,2BAA2B;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B;AACF;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;EAC7B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B,EAAE,qCAAqC;IACjE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import './variables.css';\n\n\nbody {\n  overflow-y: auto; /* Allow vertical scrolling */\n}\n\n.about-body {\n  color: white;\n}\n\n.about-wrapper {\n  /* display: flex; */\n  box-sizing: border-box;\n  /* padding-top: 64px; */\n  /* height: 100vh; */\n  background-color: var(--background-color); /* Dark background */\n  color: var(--text-color); /* Text color */\n  font-family: \"Montserrat\", sans-serif; \n}\n\n/* General Styling */\n.about-root {\n  font-family: 'Tussilago', 'Montserrat', sans-serif;\n  color: #333;\n  background-color: #f9f9f9;\n  padding: 0;\n  margin: 0;\n}\n\n.about-header {\n  text-align: center;\n  padding: 20px 0;\n  background-color: #1f2238;\n  color: white;\n}\n\n.about-logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.about-logo {\n  height: 60px;\n}\n\n.about-title {\n  font-size: 36px;\n  font-weight: bold;\n}\n\n/* Hero Section */\n.about-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 40px;\n  /* background: linear-gradient(to right, #0087e1, #111920); */\n  color: white;\n  height: 100%;\n}\n\n/* .hero-text {\n  max-width: 50%;\n} */\n\n.hero-text h2 {\n  font-size: 42px;\n  margin-bottom: 20px;\n}\n\n.hero-text p {\n  font-size: 18px;\n  line-height: 1.6;\n}\n\n.hero-image img {\n  max-width: 100%;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* Content Section */\n.about-content {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  padding: 50px;\n}\n\n.content-block {\n  background: white;\n  padding: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s;\n}\n\n.content-block:hover {\n  transform: translateY(-5px);\n}\n\n.content-block h3 {\n  font-size: 24px;\n  color: #1f2238;\n  margin-bottom: 50px;\n}\n\n.content-block p {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #666;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about-hero {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .hero-text {\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .about-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Features Section */\n.about-features {\n  padding: 50px;\n  background-color: #f2f2f2;\n  color: #333;\n  height: 100%;\n}\n\n.about-features h3 {\n  font-size: 28px;\n  margin-bottom: 20px;\n}\n\n.about-features ul {\n  list-style-type: none;\n  margin: 0;\n  padding-left: 0px;\n}\n\n.about-features li {\n  margin-bottom: 15px;\n  font-size: 16px;\n}\n\n/* FAQ Section */\n.about-faqs {\n  padding: 50px;\n  background-color: #1f2238;\n  color: white;\n  height: 100%;\n}\n\n.about-faqs h3 {\n  font-size: 28px;\n  margin-bottom: 20px;\n}\n\n.about-faqs ul {\n  /* color: #0087e1; */\n  list-style-type: none;\n  padding-left: 0px;\n  margin-left: 0px;\n}\n\n.about-faqs li {\n  color: #0087e1;\n  list-style-type: none;\n  padding-left: 0px;\n  margin-left: 0px;\n}\n\n.faq-item {\n  margin-bottom: 20px;\n}\n\n.faq-item h4 {\n  font-size: 20px;\n  margin-bottom: 10px;\n  color: #0087e1;\n}\n\n.faq-item p {\n  font-size: 18px;\n}\n\n.horizontal-about-section {\n  display: flex;\n  flex-direction: column; /* Stack content vertically */\n  align-items: center; /* Center content horizontally */\n  justify-content: center; /* Center content vertically, if needed */\n  min-width: 100vh; /* Full page width */\n  box-sizing: border-box; /* Include padding and border in width */\n  background: linear-gradient(to top, var(--background-color), #0052a4);\n  color: var(--text-color); /* Adjust as needed */\n  flex-direction: row;\n  height: 110vh;\n}\n\n.horizontal-about-section-full {\n  display: flex;\n  padding-top: 50px;\n  flex-direction: column; /* Stack content vertically */\n  align-items: center; /* Center content horizontally */\n  justify-content: center; /* Center content vertically, if needed */\n  width: 100%; /* Full page width */\n  box-sizing: border-box; /* Include padding and border in width */\n  /* padding: 50px 20px;  */\n  background: linear-gradient(to bottom, var(--background-color), #0052a4);\n  /* background-color: #0052a4; */\n  color: var(--text-color); /* Adjust as needed */\n  flex-direction: row;\n  height: 100%;\n}\n\n.horizontal-about-section-gradient {\n  display: flex;\n  flex-direction: column; /* Stack content vertically */\n  align-items: center; /* Center content horizontally */\n  justify-content: center; /* Center content vertically, if needed */\n  width: 100%; /* Full page width */\n  box-sizing: border-box; /* Include padding and border in width */\n  background: linear-gradient(to bottom, var(--background-color), var(--background-color));\n  color: var(--text-color); /* Adjust as needed */\n  flex-direction: row;\n  height: 100%;\n}\n\n.about-section-container {\n  align-items: flex-start;\n  color: rgb(255, 255, 255);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  font-family: \"Capsule Sans Text\", sans-serif;\n  justify-content: flex-start;\n  margin-left: 0px;\n  margin-right: 0px;\n  text-align: center;\n  width: 100%;\n  -moz-box-pack: start;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.about-content-wrapper {\n  color: rgb(255, 255, 255);\n  display: block;\n  font-family: \"Capsule Sans Text\", sans-serif;\n  margin-left: 0px;\n  margin-right: 0px;\n  text-align: center;\n  visibility: visible;\n  width: 100%;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.about-grid {\n  align-items: center;\n  color: rgb(255, 255, 255);\n  display: flex;\n  flex-direction: column;\n  font-family: \"Capsule Sans Text\", sans-serif;\n  text-align: center;\n  visibility: visible;\n  width: 100%;\n  -moz-box-align: center;\n  -moz-osx-font-smoothing: grayscale\n}\n\n/* .about-feature {\n  color: rgb(255, 255, 255);\n  display: flex;\n  font-family: \"Capsule Sans Text\", sans-serif;\n  height: 100%;\n  justify-content: start;\n  margin-bottom: 77px;\n  margin-top: 50px;\n  overflow-x: auto;\n  overflow-y: auto;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: none;\n  text-align: center;\n  visibility: visible;\n  width: 100%;\n  -moz-box-pack: start;\n  -moz-osx-font-smoothing: grayscale\n} */\n\n.about-feature {\n  display: grid; /* Use grid layout */\n  grid-template-columns: repeat(auto-fit, minmax(400px, 0fr)); /* Adjust column size */\n  grid-gap: 24px; /* Space between grid items */\n  color: rgb(255, 255, 255);\n  font-family: \"Capsule Sans Text\", sans-serif;\n  justify-content: center; /* Center content horizontally */\n  align-items: start; /* Align items vertically */\n  margin-bottom: 77px;\n  margin-top: 50px;\n  text-align: center;\n  visibility: visible;\n  width: 100%;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.css-131lmaj {\n  align-items: center;\n  color: rgb(255, 255, 255);\n  display: flex;\n  flex-direction: column;\n  font-family: \"Capsule Sans Text\", sans-serif;\n  height: 100%;\n  margin-left: 82.5px;\n  margin-right: 55px;\n  min-height: 100%;\n  scroll-snap-align: center;\n  scroll-snap-stop: always;\n  text-align: center;\n  visibility: visible;\n  width: 270px;\n  -moz-box-align: center;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.icon-container {\n  color: rgb(255, 255, 255);\n  font-family: \"Capsule Sans Text\", sans-serif;\n  height: 200px;\n  margin-bottom: 24px;\n  text-align: center;\n  visibility: visible;\n  width: 270px;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.feature-description {\n  color: rgb(255, 255, 255);\n  font-family: \"Montserrat\", sans-serif; \n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: -0.25px;\n  line-height: 26px;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  margin-right: 0px;\n  margin-top: 0px;\n  text-align: center;\n  visibility: visible;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.feature-title {\n  color: rgb(255, 255, 255);\n  font-family: \"Montserrat\", sans-serif; \n  font-size: 20px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: -0.25px;\n  line-height: 26px;\n  margin-bottom: 10px;\n  margin-left: 0px;\n  margin-right: 0px;\n  margin-top: 0px;\n  text-align: center;\n  visibility: visible;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.feature-icon-wrapper {\n  align-items: center;\n  color: rgb(255, 255, 255);\n  display: flex;\n  flex-direction: column;\n  font-family: \"Capsule Sans Text\", sans-serif;\n  height: 500px;\n  margin-left: 0px;\n  margin-right: 55px;\n  min-height: 100%;\n  scroll-snap-align: center;\n  scroll-snap-stop: always;\n  text-align: center;\n  visibility: visible;\n  width: 350px;\n  -moz-box-align: center;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.css-2xd1cm {\n  align-items: center;\n  color: rgb(255, 255, 255);\n  display: flex;\n  flex-direction: column;\n  font-family: \"Capsule Sans Text\", sans-serif;\n  height: 100%;\n  margin-left: 0px;\n  margin-right: 82.5px;\n  min-height: 100%;\n  scroll-snap-align: center;\n  scroll-snap-stop: always;\n  text-align: center;\n  visibility: visible;\n  width: 270px;\n  -moz-box-align: center;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.about-icon-img {\n  /* max-width: 100%; */\n  max-height: 100%;\n  /* width: 100%; */\n  height: 100%;\n}\n\n.col-acoordion {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  font-family: \"Montserrat\", sans-serif; \n  height: 100%;\n  width: 100%;\n  font-weight: 400;\n  margin-left: 40px;\n  text-align: center;\n  -moz-osx-font-smoothing: auto;\n  --section-relative-margin: 0 auto\n}\n\n.faq-container {\n  box-sizing: border-box;\n  font-family: \"Montserrat\", sans-serif; \n  font-weight: 400;\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  -moz-osx-font-smoothing: auto;\n  --section-relative-margin: 0 auto\n}\n\n.faq-item h1 {\n  font-size: 27.7392px;\n}\n\n.faq-accordion {\n  align-items: center;\n  border-bottom-color: white;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  font-family: \"Montserrat\", sans-serif; \n  font-weight: 400;\n  justify-content: space-between;\n  padding-bottom: 16px;\n  padding-left: 0px;\n  padding-right: 0px;\n  /* padding-top: 150px; */\n  position: relative;\n  text-align: center;\n  width: 548px;\n  -moz-box-align: center;\n  -moz-box-pack: justify;\n  -moz-osx-font-smoothing: auto;\n  --section-relative-margin: 0 auto\n}\n\n.faq-accordion-first {\n  align-items: center;\n  border-bottom-color: white;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  font-family: \"Montserrat\", sans-serif; \n  font-weight: 400;\n  justify-content: space-between;\n  padding-bottom: 16px;\n  padding-left: 0px;\n  padding-right: 0px;\n  margin-top: 10px;\n  position: relative;\n  text-align: center;\n  width: 548px;\n  -moz-box-align: center;\n  -moz-box-pack: justify;\n  -moz-osx-font-smoothing: auto;\n  --section-relative-margin: 0 auto\n}\n\n.faq-question {\n  box-sizing: border-box;\n  color: white;\n  cursor: pointer;\n  font-family: \"Montserrat\", sans-serif; \n  font-size: 27.7392px;\n  font-weight: 400;\n  line-height: 34px;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  margin-right: 16px;\n  margin-top: 0px;\n  overflow-wrap: break-word;\n  text-align: left;\n  -moz-osx-font-smoothing: auto;\n  --section-relative-margin: 0 auto\n}\n\n.accordion-item__icon {\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  font-family: \"Montserrat\", sans-serif; \n  font-weight: 400;\n  height: 16px;\n  min-width: 16px;\n  position: relative;\n  text-align: center;\n  width: 16px;\n  -moz-osx-font-smoothing: auto;\n  --section-relative-margin: 0 auto\n}\n\n.faq-panel {\n  box-sizing: border-box;\n  color: white;\n  font-family: \"Montserrat\", sans-serif; \n  font-weight: 400;\n  text-align: left;\n  max-width: 60%;\n  margin-bottom: 50px;\n  line-height: 27px;\n  font-size: 18px;\n  transition-behavior: normal;\n  transition-delay: 0s;\n  transition-duration: 0.25s;\n  transition-property: max-height;\n  transition-timing-function: ease-out;\n  -moz-osx-font-smoothing: auto;\n  --section-relative-margin: 0 auto\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about-hero {\n    text-align: center;\n    justify-content: center;\n    padding-top: 70px;\n  }\n\n  .hero-text h2 {\n    font-size: 24px;\n  }\n\n  .hero-text p {\n    font-size: 14px;\n  }\n\n  .about-content {\n    grid-template-columns: 1fr;\n    padding: 16px;\n  }\n\n  .content-block h3 {\n    font-size: 18px;\n  }\n\n  .content-block p {\n    font-size: 12px;\n  }\n\n  .about-features {\n    padding: 16px;\n  }\n\n  .about-features h3 {\n    font-size: 20px;\n  }\n\n  .about-faqs {\n    padding: 16px;\n  }\n\n  .faq-item h4 {\n    font-size: 16px;\n  }\n\n  .faq-panel p {\n    font-size: 12px;\n  }\n\n  .faq-question {\n    font-size: 20px;\n  }\n\n  .faq-item h1 {\n    font-size: 20px;\n  }\n\n  .faq-accordion-first {\n    width: 100%;\n  }\n\n  .faq-accordion {\n    width: 100%;\n  }\n\n  .feature-icon-wrapper {\n    width: 100%;\n    height: 100%;\n  }\n\n  .feature-description {\n    font-size: 12px;\n    width: 70%;\n  }\n\n  .feature-title {\n    width: 70%;\n  }\n\n  .horizontal-about-section,\n  .horizontal-about-section-full,\n  .horizontal-about-section-gradient {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 1080px) {\n  .horizontal-about-section {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .about-hero {\n    padding-top: 70px;\n    padding-bottom: 0px;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .horizontal-about-section {\n    padding: 16px;\n    flex-direction: column;\n    min-width: auto;\n    height: 100%;\n  }\n\n  .about-hero .hero-text h2 {\n    font-size: 24px;\n    margin-bottom: 12px;\n  }\n\n  .about-hero .hero-text p {\n    font-size: 14px;\n  }\n\n  .about-content {\n    grid-template-columns: 1fr; /* Stacks content blocks vertically */\n    padding: 16px;\n    gap: 12px;\n  }\n\n  .content-block h3 {\n    font-size: 18px;\n  }\n\n  .content-block p {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-hero .hero-text h2 {\n    font-size: 20px;\n  }\n\n  .about-hero .hero-text p {\n    font-size: 12px;\n  }\n\n  .content-block h3 {\n    font-size: 16px;\n  }\n\n  .content-block p {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
